import React from "react";
import styles from "./StepToggle.module.css";

const StepToggle = ({ options = [], value, onChange, circular = false }) => {
  return (
    <div className={`${styles.toggleWrapper} ${circular ? styles.circularOptions : ""}`}>
      {options.map((option) => {
        const isActive = option === value;

        return (
          <div
            key={option}
            className={`${styles.option} ${circular ? styles.circularOptions : ""} ${isActive ? styles.active : ""}`}
            onClick={() => onChange(option)}
          >
            {option}
          </div>
        );
      })}
    </div>
  );
};

export default StepToggle;